import { Column, Img, Link, Row, Section, Text } from "@react-email/components";
import { Email as Styles } from "themes/styles";
import { StepConfig } from "assets/data";
import { Helpers, Routes } from "utils";

export const Footnote = () => {
  const [one, _, three, four] = StepConfig;

  return (
    <div style={Styles.footnote.content}>
      <Text style={Styles.footnote.header}>How does it work?</Text>
      <Section>
        <Row>
          <Column style={Styles.footnote.column}>
            <Img style={Styles.thumb} src={Helpers.getImage(one.src)} />
          </Column>
          <Column style={Styles.footnote.column}>
            <Img style={Styles.thumb} src={Helpers.getImage(three.src)} />
          </Column>
          <Column style={Styles.footnote.column}>
            <Img style={Styles.thumb} src={Helpers.getImage(four.src)} />
          </Column>
        </Row>
        <Row>
          <Column style={Styles.footnote.column}>
            <Text style={Styles.textBold}>{one.title}</Text>
          </Column>
          <Column style={Styles.footnote.column}>
            <Text style={Styles.textBold}>{three.title}</Text>
          </Column>
          <Column style={Styles.footnote.column}>
            <Text style={Styles.textBold}>{four.title}</Text>
          </Column>
        </Row>
        <Row>
          <Column style={Styles.footnote.column}>
            <Text style={Styles.text}>{one.description}</Text>
          </Column>
          <Column style={Styles.footnote.column}>
            <Text style={Styles.text}>{three.description}</Text>
          </Column>
          <Column style={Styles.footnote.column}>
            <Text style={Styles.text}>{four.description}</Text>
          </Column>
        </Row>
        <Row>
          <Column>
            <Text style={Styles.footnote.note}>
              <Link
                href={Helpers.generateInterpolatedUrl(Routes.auth)}
                style={Styles.link}
              >
                Join Potluck'IN
              </Link>{" "}
              for free today—create, vote, and feast your way to the ultimate
              potluck experience!
            </Text>
          </Column>
        </Row>
      </Section>
    </div>
  );
};
